export function isWalletV2Enabled(): boolean {
  return process.env.REACT_APP_ENABLE_WALLET_V2 === 'true'
}
